import { Module } from 'vuex';

import { ContextState } from '../../models';

import { ClearFiltersAction } from '../../store/context/actions/clear-filters.action';
import { ClearModuleAction } from '../../store/context/actions/clear-module.action';
import { SetContextAction } from '../../store/context/actions/set-context.action';
import { SetFiltersSelectedValuesAction } from '../../store/context/actions/set-filters-selected-values.action';
import { SetQueryAction } from '../../store/context/actions/set-query.action';
import { CONTEXT_CONSTS } from '../../store/context/context.consts';
import { AppliedFiltersCountGetter } from '../../store/context/getters/applied-filters-count.getter';
import { ContextGetter } from '../../store/context/getters/context.getter';
import { EnabledFiltersGetter } from '../../store/context/getters/enabled-filters.getter';
import { FiltersAreValidGetter } from '../../store/context/getters/filters-are-valid.getter';
import { ClearModuleMutation } from '../../store/context/mutations/clear-module.mutation';
import { SetContextMutation } from '../../store/context/mutations/set-context.mutation';

export const CONTEXT_MODULE: Module<ContextState, any> = {
  namespaced: true,

  state: (): ContextState => {
    return {
      instanceId: undefined,
      environment: undefined,
      domain: undefined,
      filters: {},
      query: undefined
    };
  },

  getters: {
    [CONTEXT_CONSTS.getters.context]: ContextGetter.execute,

    [CONTEXT_CONSTS.getters.enabledFilters]: EnabledFiltersGetter.execute,
    [CONTEXT_CONSTS.getters.appliedFiltersCount]: AppliedFiltersCountGetter.execute,
    [CONTEXT_CONSTS.getters.filtersAreValid]: FiltersAreValidGetter.execute
  },

  actions: {
    [CONTEXT_CONSTS.actions.setContext]: SetContextAction.execute,

    [CONTEXT_CONSTS.actions.setFiltersSelectedValues]: SetFiltersSelectedValuesAction.execute,
    [CONTEXT_CONSTS.actions.clearFilters]: ClearFiltersAction.execute,
    [CONTEXT_CONSTS.actions.setQuery]: SetQueryAction.execute,

    [CONTEXT_CONSTS.actions.clearModule]: ClearModuleAction.execute
  },

  mutations: {
    [CONTEXT_CONSTS.mutations.setContext]: SetContextMutation.execute,

    [CONTEXT_CONSTS.mutations.clearModule]: ClearModuleMutation.execute
  }

};
